import React, { useEffect, useState } from 'react'
import { useShouZhiListQuery } from '../../store/BnsKeJiApi';
import { Table } from 'antd';
import Main from '../../cpn/Main';

function YwzBalanceList() {
    const [list, setList] = useState();    
    const {data, isSuccess} = useShouZhiListQuery({
            "e_date" : '',
            "eie_e_id" : '',
            "eie_state" : '',
            "s_date" :'',
        },{refetchOnMountOrArgChange:1});    
    useEffect(() => {
        if(isSuccess){            
            if(data.Status==='success'){
                const newArr = data.Result.map(item => {
                    const {eie_id:key,eie_type_id,eie_arrive_year,eie_egg_value,eie_arrive_month,eie_arrive_day,eie_finance_sub_type_name,eie_hx_ctime,ed_name,eie_jbr_uname,eie_audit1_ctime,eie_audit1_uname,eie_audit2_ctime,eie_audit3_ctime,eie_audit3_uname,eie_audit4_uname,eie_audit4_ctime,eie_audit2_uname,eie_hx_year,eie_hx_month,eie_hx_day,eie_amount,ec_name,eie_ebn_id,eie_content,eie_uname,eie_ctime,eie_update_ctime,eie_update_uname,eie_price,eie_image_file,eie_count,eci_name,eg_name,eu_name,eie_hx_number,eie_bank_log_id,eie_yw_name,ebn_team_num,eie_bank_ctime,eie_state} = item;
                    let type = ''
                        switch (eie_type_id) {
                            case '1'://销售收入
                            type = '团队收入'
                                break;
                            case '2'://成本支出
                            type = '团队支出'
                                break;
                            case '3'://费用支出
                            type = '费用支出'
                                break;
                            case '4'://其他收入
                            type = '其他收入'
                                break;
                            case '5'://其他支出
                            type = '其他支出'
                                break;              
                            default:
                                break;
                        }
                    return item = {key,eie_type_id,eie_arrive_year,eie_egg_value,eie_arrive_month,eie_arrive_day,eie_finance_sub_type_name,eie_hx_ctime,ed_name,eie_jbr_uname, eie_audit1_ctime,eie_audit1_uname,eie_audit2_ctime,eie_audit3_ctime,eie_audit4_ctime,eie_audit3_uname,eie_audit4_uname,eie_audit2_uname,eie_hx_year,eie_hx_month,eie_hx_day,eie_amount,ec_name,eie_ebn_id,eie_content,eie_uname,eie_ctime,eie_update_ctime,eie_update_uname,eie_price,eie_image_file,eie_count,eci_name,eg_name,eu_name,eie_hx_number,eie_bank_log_id,eie_yw_name,type,ebn_team_num,eie_bank_ctime,eie_state}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.eie_ctime;
                    let bTimeString = b.eie_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
                
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])   
    const columns = [
        {
            key: 'id',
            title: '编号',
            dataIndex: 'key',   
           
        },        
        {
            key: 'eie_finance_sub_type_name',
            title: '类型',
            dataIndex: 'eie_finance_sub_type_name',
            render:(text,record) => {
                return record.type + ' - ' + text
            }
        },  
        {
            key: 'ebn_team_num',
            title: '团队编号',
            dataIndex: 'ebn_team_num',
           
        },  
        {
            key: 'client',
            title: '客户',
            dataIndex: 'ec_name',
        },                           
        {
            key: 'eie_amount',
            title: '金额',
            dataIndex: 'eie_amount',
            render:(text) => {
                if(text<0){
                    return <span style={{color:'green',fontSize:"16px"}}>{text}</span>
                }else{
                    return <span style={{color:'red',fontSize:"16px"}}>{text}</span>
                }
            }
        },                      
        {
            key: 'eie_content',
            title: '备注',
            dataIndex: 'eie_content',
        },  
        {
            key: 'eie_yw_name',
            title: '销售员',
            dataIndex:'eie_yw_name',
        },             
                                                 
        {
            key: 'ed_name',
            title: '部门',
            dataIndex: 'ed_name'
        },                                          
                                                
        {
            key: 'status',
            title: '审核',
            width:'6%',
           
        },             
        {
            key: 'hx',
            title: '下账转账',
            
            width:'6%'
        },            
             
        {
            key: 'time',
            title: '操作记录',
            render: (_,record) => {
                return <>
                    <div>新建时间：{record.eie_ctime + record.eie_uname}</div>
                    <div>修改时间：{record.eie_update_ctime + record.eie_update_uname}</div>
                </>
            }
        },
       
    ]
    return (
        <Main  t1='收支' >
            <Table 
                columns={columns} 
                dataSource={list}  
                style={{marginTop:"20px"}}   
                pagination={{
                    pageSize:20,
                    showSizeChanger:true,
                    showTotal:(total) => `共${total}条`,
                }}            
            />
        </Main>
    )
}

export default YwzBalanceList